import React, { Component } from 'react'
import PropTypes from 'prop-types'

class SocialShare extends Component {
    static propTypes = {
        type: PropTypes.oneOf(['Facebook', 'LinkedIn', 'Twitter']).isRequired,
    }

    openPoupUp(type) {
        let href = this.props.href || window.location.href
        let intWidth = 500
        let intHeight = 400
        let strTitle = ''
        switch (type) {
            case 'Facebook':
                href = 'https://www.facebook.com/sharer.php?u=' + href
                strTitle = 'Share on Facebook'
                break;
            case 'Twitter':
                href = 'https://twitter.com/share?url=' + href
                strTitle = 'Share on Twitter'
                break;
            case 'Linkedin':
                href = 'https://www.linkedin.com/shareArticle?mini=true&url=' + href
                strTitle = 'Share on LinkedIn'
                break;
            default:
                break;
        }
        let strParam = 'width=' + intWidth + ',height=' + intHeight + ',resizable=true'       
        window.open(href, strTitle, strParam).focus()
    }
    
    render() {
        return (
            <span style={{
                ...this.props.style,
                display: 'inline-block',
                cursor: 'pointer'
            }} onClick={() => this.openPoupUp(this.props.type)}>
                {this.props.children}
            </span>
        )
    }
}

export default SocialShare


// WEBPACK FOOTER //
// ./src/SPRINTA/atoms/SocialShare/index.js